import { useTheme } from '@mui/material';
import { rem } from '@utils';


export const sx = () => {
    const { typography, palette } = useTheme();

    const css = {
        divider: {
            width: '100%',
            height: '0.125rem',
            borderBottom: `1px dashed ${palette.cityLights}`,
        },
        texts: {
            balanceInPoints: {
                fontWeight: typography.fontWeightMedium,
                fontSize: rem(12),
            },
            expandedValueText: {
                fontWeight: typography.fontWeightMedium,
                fontSize: rem(12),
            },
            expandedValueChildren: {
                fontWeight: typography.fontWeightBold,
                fontSize: rem(12),
            },
            expandedMainValueChildren: {
                fontWeight: typography.fontWeightBold,
                fontSize: rem(14),
            },
        },
        alert: {
            wrapper: {
                backgroundColor: palette.primaryColor+'08',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                p: 1,
                mt: 3,
                color: palette.primaryColor,
            },
            text: {
                ml: 1,
                fontSize: '0.75rem',
            },
        },
    };

    return { css };
};
